import { render } from "./PreferencesConfig.vue?vue&type=template&id=7cb36e16&scoped=true"
import script from "./PreferencesConfig.vue?vue&type=script&lang=js"
export * from "./PreferencesConfig.vue?vue&type=script&lang=js"

import "./PreferencesConfig.vue?vue&type=style&index=0&id=7cb36e16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb36e16"]])

export default __exports__